import {
  getLoyaltyTransaction as publicGetLoyaltyTransaction,
  queryLoyaltyTransactions as publicQueryLoyaltyTransactions,
  typedQueryLoyaltyTransactions as publicTypedQueryLoyaltyTransactions,
} from './loyalty-transaction-v1-loyalty-transaction-transactions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  LoyaltyTransactionQuery,
  LoyaltyTransactionsQueryBuilder,
  typedQueryLoyaltyTransactions as universalTypedQueryLoyaltyTransactions,
} from './loyalty-transaction-v1-loyalty-transaction-transactions.universal.js';

function customQueryLoyaltyTransactions(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryLoyaltyTransactions(httpClient)(),
    typedQueryFunction: (query: LoyaltyTransactionQuery) =>
      publicTypedQueryLoyaltyTransactions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): LoyaltyTransactionsQueryBuilder;
  function overloadedQuery(
    query: LoyaltyTransactionQuery
  ): ReturnType<typeof universalTypedQueryLoyaltyTransactions>;
  function overloadedQuery(query?: LoyaltyTransactionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getLoyaltyTransaction: MaybeContext<
  BuildRESTFunction<typeof publicGetLoyaltyTransaction> &
    typeof publicGetLoyaltyTransaction
> = /*#__PURE__*/ createRESTModule(publicGetLoyaltyTransaction);
export const queryLoyaltyTransactions: MaybeContext<
  BuildRESTFunction<typeof customQueryLoyaltyTransactions> &
    typeof customQueryLoyaltyTransactions
> = /*#__PURE__*/ createRESTModule(customQueryLoyaltyTransactions);

export {
  TransactionType,
  SortOrder,
  WebhookIdentityType,
} from './loyalty-transaction-v1-loyalty-transaction-transactions.universal.js';
export {
  LoyaltyTransaction,
  LoyaltyTransactionTransactionTypeInfoOneOf,
  EarnInfo,
  EarnInfoActivityDetailsOneOf,
  FollowedSocialMedia,
  RedeemInfo,
  AdjustInfo,
  RefundInfo,
  ExpireInfo,
  EarnAttemptInfo,
  CreateLoyaltyTransactionRequest,
  CreateLoyaltyTransactionResponse,
  BulkCreateLoyaltyTransactionsRequest,
  BulkCreateLoyaltyTransactionsResponse,
  ItemMetadata,
  ApplicationError,
  BulkLoyaltyTransactionResult,
  BulkActionMetadata,
  GetLoyaltyTransactionRequest,
  GetLoyaltyTransactionResponse,
  QueryLoyaltyTransactionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryLoyaltyTransactionsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  GetTransactionSumRequest,
  GetTransactionSumResponse,
  RevertTransactionRequest,
  RevertTransactionResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  LoyaltyTransactionsQueryResult,
  LoyaltyTransactionsQueryBuilder,
  LoyaltyTransactionQuerySpec,
} from './loyalty-transaction-v1-loyalty-transaction-transactions.universal.js';
export { utils } from './loyalty-transaction-v1-loyalty-transaction-transactions.universal.js';
export {
  TransactionTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  LoyaltyTransactionQuery,
} from './loyalty-transaction-v1-loyalty-transaction-transactions.universal.js';
